/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface AgreementPreview
 */
export interface AgreementPreview {
  /**
   * A download url for a pdf to preview the current state of an agreement.
   * @type string
   * @memberof AgreementPreview
   */
  pdfPreview?: string
}

export function AgreementPreviewFromJSON(json: any): AgreementPreview {
  return AgreementPreviewFromJSONTyped(json, false)
}

export function AgreementPreviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AgreementPreview {
  if (json === undefined || json === null) {
    return json
  }
  return {
    pdfPreview: !exists(json, 'pdfPreview') ? undefined : json['pdfPreview'],
  }
}

export function AgreementPreviewToJSON(value?: AgreementPreview | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    pdfPreview: value.pdfPreview,
  }
}
